export default __webpack_public_path__ + "static/media/nanny3.6c3202e2.jpg";